(function ($) {
    var sportdataSearchFormClass = {};
    sportdataSearchFormClass.run = function (formInstance) {
        // private variables
        var thisSearchForm = $(formInstance);
        if (!$(thisSearchForm).hasClass("sportdata-search-form")) {
            thisSearchForm = $(formInstance).closest(".sportdata-search-form");
        }

        // private methods
        var submit = function () {
            var currentURL = window.sportdata_BASE_URL;
            var pathName = location.pathname;
            var newParams = [];
            var newQuery = [];
            var searchType = thisSearchForm.data('search-type');
            if (searchType === 'filter') {
                currentURL += '/ippica/';
            }

            var c = thisSearchForm.find('[name=disciplina]').first();
            if (c.length === 1) {
                if (searchType === 'generic') {
                    newQuery.push("disciplina=" + encodeURIComponent(c.val()));
                } else {
                    if (c.val().trim().length > 0) {
                        newParams.push(c.val());
                    }
                }
            }

            var today = new Date();
            today.setUTCHours(0, 0, 0, 0);

            if (searchType === 'filter') {
                var section = thisSearchForm.data("section");
                if (section.length > 0) {
                    newParams.push(section);
                } else {
                    c = thisSearchForm.find('[name=data_corsa]').first();
                    if (c.length === 1 && c.val().trim().length > 0) {
                        if (Date.parse(c.val()) < today) {
                            newParams.push('risultati');
                        } else {
                            newParams.push('partenti');
                        }
                    }
                }

                c = thisSearchForm.find('[name=ippodromo]').first();
                if (c.length === 1 && c.val().trim().length > 0) {
                    newParams.push(c.val().toLowerCase());
                }

                c = thisSearchForm.find('[name=data_corsa]').first();
                if (c.length === 1 && c.val().trim().length > 0) {
                    newParams.push(c.val().replaceAll("-", "/"));
                }
            }

            c = thisSearchForm.find('[name=s]').first();
            if (c.length === 1 && searchType === 'generic') {
                newQuery.push("s=" + encodeURIComponent(c.val()));
            }
            c = thisSearchForm.find('[name=name_filter]').first();
            if (searchType === 'filter' && c.length === 1 && c.val().trim().length > 0) {
                newQuery.push("name_filter=" + encodeURIComponent(c.val()));
            }
            c = thisSearchForm.find('[name=soggetti]').first();
            if (c.length === 1) {
                newQuery.push("soggetti=" + encodeURIComponent(c.val()));
            }

            if (newParams.length > 0) {
                currentURL += newParams.join("/") + "/";
            }
            if (newQuery.length > 0) {
                currentURL += "?" + newQuery.join("&");
            }

            window.location = currentURL;
        };

        // public API
        return {
            submit: submit,
        };
    };


    $("form.sportdata-search-form").on("submit", function (event) {
        event.preventDefault();
        event.stopPropagation();

        var sportdataSearchForm = new sportdataSearchFormClass.run($(this));
        sportdataSearchForm.submit();
    });
})(jQuery);
